'use client';

import useSWR from 'swr';

import { useFlags } from 'launchdarkly-react-client-sdk';

import { API_URLS, SWR_REQUEST_DEFAULTS } from '@/lib/api/config';

import { TypeSubEngineSubscriptionsResponse } from '../types';

type SubEngineSubscriptions = {
  userUuid: string;
  type?: string;
};

export default function useSubEngineSubscriptions({
  userUuid,
  type,
}: SubEngineSubscriptions) {
  const { 'sub-squad-enable-the-reading-club-lp': isERCEnabled } = useFlags();

  const urlSearchParams = new URLSearchParams();

  if (type) {
    urlSearchParams.append('type', type);
  }

  const url = `${API_URLS.SUBSCRIPTION_MANAGER_PROXY}/sub_engine/users/${userUuid}/subscriptions${urlSearchParams.size > 0 ? `?${urlSearchParams}` : ''}`;

  const { data, error, isLoading, mutate } = useSWR<
    TypeSubEngineSubscriptionsResponse,
    Error
  >(
    isERCEnabled ? url : null, // conditionally fetch
    SWR_REQUEST_DEFAULTS,
  );

  return {
    data,
    error,
    isLoading,
    refetch: mutate,
  };
}
